<div
	class="flex items-center justify-between cursor-pointer"
	(click)="toggleStage()"
	[testHook]="testHooks.ToggleStageDiv"
>
	<div class="flex items-center gap-4 w-full hover-container">
		<p class="cursor-pointer text-base font-bold">{{ stage.title }}</p>
		<div class="items-center gap-2 hover-icons">
			<ng-content></ng-content>
			<app-icon
				[icon]="ICON.DELETE"
				class="cursor-pointer text-grey-dark"
				(click)="deleteStage(stage.id)"
				[testHook]="testHooks.DeleteIcon"
			></app-icon>
		</div>
	</div>
	<div class="flex items-center gap-2">
		<circle-progress
			[percent]="completedPercentage$ | async"
			[radius]="16"
			[outerStrokeWidth]="4"
			[innerStrokeWidth]="0"
			[titleFontSize]="10"
			[showSubtitle]="false"
			outerStrokeColor="green"
			[animation]="false"
		></circle-progress>
		<p class="text-sm w-16">{{ (tasks$ | async)?.length }} tasks</p>
		<app-icon
			[icon]="isOpened ? ICON.UP : ICON.DOWN"
			class="ml-2 cursor-pointer"
			[testHook]="testHooks.DownIcon"
		></app-icon>
	</div>
</div>
<div
	[ngClass]="{
		'flex flex-col gap-3 min-h-[10px]': true,
		'm-2': stage.tasks?.length > 0,
	}"
	*ngIf="isOpened"
	[@openClose]
	[id]="getStageElementId(stage)"
	[cdkDropListConnectedTo]="getConnectedStages(stage)"
	cdkDropList
	[cdkDropListData]="stage.tasks"
	(cdkDropListDropped)="dropTask($event)"
>
	<div
		class="flex gap-3 items-center hover-container"
		*ngFor="let task of tasks$ | async; trackBy: trackByFunction"
		cdkDrag
	>
		<app-checkbox
			type="clear"
			[ngModel]="task.complete"
			(ngModelChange)="toggleChecklistTask(task.id, $event)"
			[testHook]="testHooks.ToggleChecklistTaskCheckbox"
		></app-checkbox>
		<p>{{ task.title }}</p>
		<div>
			<app-icon
				*ngIf="task.fieldPath"
				class="text-grey-light w-6 h-6"
				[icon]="ICON.INFO_SQUARE"
				matTooltip="Synced with Upcoming Requisitions"
				[testHook]="testHooks.InfoSquareIcon"
			></app-icon>
		</div>
		<div class="items-center gap-2 hover-icons">
			<app-icon
				[icon]="ICON.SORT"
				class="cursor-pointer text-grey-dark"
				cdkDragHandle
				[testHook]="testHooks.SortIcon"
			></app-icon>
			<app-icon
				[icon]="ICON.DELETE"
				class="cursor-pointer text-grey-dark"
				(click)="deleteTask(task.id)"
				[testHook]="testHooks.DeleteIcon1"
			></app-icon>
		</div>
	</div>
</div>
<app-input
	(onBlur)="addTaskInputBlur()"
	[autofocus]="true"
	*ngIf="addingTask"
	[(ngModel)]="newTask"
	class="m-2 mb-4"
	(keyup.enter)="saveNewTask()"
	[testHook]="testHooks.NewTask"
></app-input>
<p
	class="text-green text-sm m-2 mb-4 cursor-pointer"
	*ngIf="isOpened && !addingTask"
	(click)="addTask()"
>
	<app-icon [icon]="ICON.ADD" [testHook]="testHooks.AddIcon"></app-icon>
	Add task
</p>
